<template>
  <div>
    <div class="toolbar">
      <el-input
        v-model="keyword"
        clearable
        placeholder="单号 / 材料"
        style="width:200px"
        @keyup.enter.native="load"
      />
      <el-select v-model="receiveStatus" clearable placeholder="收货状态" style="width:130px" @change="load">
        <el-option v-for="(v,k) in materialReceiveStatusMap" :key="k" :label="v.label" :value="k" />
      </el-select>
      <el-button type="primary" icon="el-icon-search" @click="load">查询</el-button>
      <el-button icon="el-icon-download" :loading="exporting" :disabled="!list.length" @click="onExport">导出</el-button>
    </div>

    <el-table
      :data="pageList"
      border
      v-loading="loading"
      show-summary
      :summary-method="summaryMethod"
    >
      <el-table-column prop="reqNo" label="申请单号" width="160" show-overflow-tooltip />
      <el-table-column prop="projectName" label="项目" min-width="140" show-overflow-tooltip />
      <el-table-column prop="stageName" label="工序" width="110" show-overflow-tooltip>
        <template slot-scope="{ row }">{{ row.stageName || '-' }}</template>
      </el-table-column>
      <el-table-column label="使用日期" width="120">
        <template slot-scope="{ row }">{{ fmtDate(row.needDate) }}</template>
      </el-table-column>
      <el-table-column prop="materialName" label="材料" min-width="140" show-overflow-tooltip />
      <el-table-column prop="specs" label="规格" width="110" show-overflow-tooltip>
        <template slot-scope="{ row }">{{ row.specs || '-' }}</template>
      </el-table-column>
      <el-table-column prop="unit" label="单位" width="70" align="center">
        <template slot-scope="{ row }">{{ row.unit || '-' }}</template>
      </el-table-column>
      <el-table-column prop="qty" label="申请数量" width="90" align="right">
        <template slot-scope="{ row }">{{ fmtQty(row.qty) }}</template>
      </el-table-column>
      <el-table-column prop="receivedQty" label="已收数量" width="90" align="right">
        <template slot-scope="{ row }">{{ fmtQty(row.receivedQty) }}</template>
      </el-table-column>
      <el-table-column prop="returnedQty" label="退货数量" width="90" align="right">
        <template slot-scope="{ row }">{{ fmtQty(row.returnedQty) }}</template>
      </el-table-column>
      <el-table-column prop="actualQty" label="实收数量" width="90" align="right">
        <template slot-scope="{ row }">{{ fmtQty(row.actualQty) }}</template>
      </el-table-column>
      <el-table-column prop="costPrice" label="采购单价" width="100" align="right">
        <template slot-scope="{ row }">{{ formatMoney(row.costPrice) }}</template>
      </el-table-column>
      <el-table-column prop="amount" label="实收金额" width="110" align="right">
        <template slot-scope="{ row }">{{ formatMoney(amount(row)) }}</template>
      </el-table-column>
      <el-table-column label="收货状态" width="100" align="center">
        <template slot-scope="{ row }">
          <el-tag size="mini" :type="statusType(materialReceiveStatusMap, row.receiveStatus || 'NONE')">
            {{ statusLabel(materialReceiveStatusMap, row.receiveStatus || 'NONE') }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createdByName" label="申请人" width="100" show-overflow-tooltip>
        <template slot-scope="{ row }">{{ row.createdByName || '-' }}</template>
      </el-table-column>
      <el-table-column label="申请时间" width="120">
        <template slot-scope="{ row }">{{ fmtDate(row.createdAt) }}</template>
      </el-table-column>
    </el-table>
    <list-pagination
      :total="listTotal"
      :page="page"
      :page-size="pageSize"
      @current-change="onPageChange"
      @size-change="onPageSizeChange"
    />
  </div>
</template>

<script>
import { listSupplierMaterialReqLines, exportSupplierMaterialReqLines } from '../../api/supply'
import { materialReceiveStatusMap, statusLabel, statusType } from '../../utils/status'
import ListPagination from '../../components/ListPagination.vue'
import listPaging from '../../mixins/listPaging'

const SUM_PROPS = new Set(['qty', 'receivedQty', 'returnedQty', 'actualQty', 'amount'])

export default {
  name: 'SupplierReqLines',
  components: { ListPagination },
  mixins: [listPaging],
  data() {
    return {
      materialReceiveStatusMap,
      keyword: '',
      receiveStatus: '',
      list: [],
      loading: false,
      exporting: false
    }
  },
  created() {
    this.load()
  },
  methods: {
    statusLabel,
    statusType,
    num(v) {
      const n = Number(v)
      return Number.isFinite(n) ? n : 0
    },
    fmtQty(v) {
      if (v == null || v === '') return '0'
      const n = this.num(v)
      if (Number.isInteger(n)) return String(n)
      return String(Math.round(n * 10000) / 10000)
    },
    formatMoney(v) {
      return this.num(v).toFixed(2)
    },
    fmtDate(v) {
      if (!v) return '-'
      return String(v).slice(0, 10)
    },
    amount(row) {
      if (row && row.amount != null && row.amount !== '') return this.num(row.amount)
      return Math.round(this.num(row && row.actualQty) * this.num(row && row.costPrice) * 100) / 100
    },
    summaryMethod({ columns }) {
      const sums = []
      const rows = this.list || []
      columns.forEach((col, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        const prop = col.property
        if (!SUM_PROPS.has(prop)) {
          sums[index] = ''
          return
        }
        let total = 0
        rows.forEach(row => {
          if (prop === 'amount') total += this.amount(row)
          else total += this.num(row[prop])
        })
        sums[index] = prop === 'amount' ? this.formatMoney(total) : this.fmtQty(total)
      })
      return sums
    },
    queryParams() {
      return {
        keyword: this.keyword || undefined,
        receiveStatus: this.receiveStatus || undefined
      }
    },
    async load() {
      this.loading = true
      try {
        const res = await listSupplierMaterialReqLines(this.queryParams())
        this.list = res.data || []
        this.page = 1
      } finally {
        this.loading = false
      }
    },
    async onExport() {
      if (!this.list.length) {
        return this.$message.warning('暂无数据可导出')
      }
      this.exporting = true
      try {
        const res = await exportSupplierMaterialReqLines(this.queryParams())
        const blob = new Blob([res.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        })
        const url = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = '申请明细.xlsx'
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        URL.revokeObjectURL(url)
      } catch (e) {
        this.$message.error('导出失败')
      } finally {
        this.exporting = false
      }
    }
  }
}
</script>

<style scoped>
.toolbar { display: flex; gap: 8px; margin-bottom: 12px; flex-wrap: wrap; }
</style>
